import React, { useContext, useMemo } from 'react';
import Layout from '../../components/layout/main';
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Chip,
    Fade,
    Grid,
    Paper,
    Typography,
} from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import ApartmentIcon from '@mui/icons-material/Apartment';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';
import { APP_NAME, APP_SHORT_NAME } from '../../const/app';
import { AuthContext } from '../../context/auth';

function Page() {
    const navigate = useNavigate();
    const { usuario } = useContext(AuthContext);

    const canPersonal = useMemo(
        () => usuario && (usuario.nivel_usuario === 1 || usuario.sup_personal === true),
        [usuario]
    );
    const canAreas = useMemo(
        () => usuario && (usuario.nivel_usuario === 1 || usuario.sup_areas === true),
        [usuario]
    );
    const canUsuarios = useMemo(
        () => usuario && (usuario.nivel_usuario === 1 || usuario.sup_usuarios === true),
        [usuario]
    );

    const accesos = [
        {
            label: 'Personal',
            detail: 'Alta y administración de empleados, vinculaciones y credenciales QR.',
            icon: BadgeIcon,
            url: '/personal',
            visible: canPersonal,
        },
        {
            label: 'Áreas (CUOF)',
            detail: 'Administración de áreas con su Código Único de Oficina.',
            icon: ApartmentIcon,
            url: '/area',
            visible: canAreas,
        },
        {
            label: 'Credenciales QR',
            detail: 'Emisión y revocación de credenciales desde el detalle de cada empleado.',
            icon: QrCode2Icon,
            url: '/personal',
            visible: canPersonal,
        },
        {
            label: 'Usuarios del sistema',
            detail: 'Gestión de usuarios internos y permisos.',
            icon: PeopleIcon,
            url: '/usuario',
            visible: canUsuarios,
        },
    ];

    return (
        <Layout nombrePagina="Panel de inicio">
            <Fade in={true} timeout={600}>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 3,
                                background: (t) =>
                                    t.palette.mode === 'light'
                                        ? 'linear-gradient(135deg, rgba(0, 32, 58, 0.06) 0%, rgba(0, 32, 58, 0.02) 100%)'
                                        : 'linear-gradient(135deg, rgba(80, 89, 188, 0.16) 0%, rgba(80, 89, 188, 0.05) 100%)',
                                border: (t) => `1px solid ${t.palette.divider}`,
                                borderRadius: 2,
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 1.5 }}>
                                <Chip label={APP_SHORT_NAME} size="small" color="primary" />
                            </Box>
                            <Typography variant="h5" fontWeight={600} gutterBottom>
                                {APP_NAME}
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 760 }}>
                                Administración de personal del <strong>Ministerio de Salud de la Provincia del Chaco</strong>.
                                El módulo prioritario es la emisión y verificación pública de credenciales con QR. Usá los
                                accesos rápidos o el menú lateral para comenzar.
                            </Typography>
                        </Paper>
                    </Grid>

                    {accesos.filter((a) => a.visible).map((acceso) => {
                        const Icon = acceso.icon;
                        return (
                            <Grid key={acceso.label} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                                <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
                                    <CardActionArea onClick={() => navigate(acceso.url)} sx={{ height: '100%' }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                                                <Icon color="primary" sx={{ fontSize: 28 }} />
                                                <Typography variant="subtitle1" fontWeight={600}>
                                                    {acceso.label}
                                                </Typography>
                                            </Box>
                                            <Typography variant="body2" color="text.secondary">
                                                {acceso.detail}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Fade>
        </Layout>
    );
}

export default Page;
